import React, { useState, useEffect } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getDriverTripById } from "../../../shared/api/action/DriverActions";

const PatternsDriverIdContainer = (props) => {
	const navigate = useNavigate();
	const params = useParams();
	const { t } = useTranslation('translation', { keyPrefix: 'patternsPage' });
	const { toggleLoader } = props;

	const [error, setError] = useState('');

	useEffect(() => {
		getDriverTrip();
	}, []);

	const getDriverTrip = () => {
		toggleLoader(true);

		const { driver_trip_id} = params;
		getDriverTripById({ driver_trip_id })
			.then((res, err) => {
				const { driver_trip } = res.data.response
				props.setSelectedObject(driver_trip)
				// ToDo: Check this: No /fleet-admin/driver router in App. May be external?
				navigate('/fleet-admin/driver', {
					state: {
						type: 'driverid',
					},
				});
			})
			.catch((error) => {
				console.log('!getDriverTrip error', error.response, error)

				let _error = JSON.stringify(error);
				if (error.response && error.response.data.response.error) {
					_error = error.response.data.response.error
				}
				setError(_error);
			})
	}

	return (
		<article>
			{error
				&& (
					<div>
						<h3>{t('error404')}</h3>
						<div>{error}</div>
						<div>
							{t('goBack')}
							<Link to="/" className="btn">{t('btnHome')}</Link>
						</div>
					</div>
				)}
		</article>
	)
}

export default connect(
	state => ({
		user: state.user,
		company: state.company,
	}),
	dispatch => ({
		updateCompany: (company) => {
			dispatch({ type: 'GET_COMPANY_SUCCESS', payload: company })
		},
		setSelectedObject: (state) => {
			dispatch({ type: 'SET_OBJECT_NOTIFICATIONS', payload: state })
		},
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(PatternsDriverIdContainer);
